'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Label = function Label(_ref) {
  var value = _ref.value,
      minValue = _ref.minValue,
      maxValue = _ref.maxValue,
      name = _ref.name,
      postfix = _ref.postfix,
      className = _ref.className,
      labelClassName = _ref.labelClassName,
      labelValueClassName = _ref.labelValueClassName,
      labelValueFunction = _ref.labelValueFunction,
      customLabelFunction = _ref.customLabelFunction,
      prefix = _ref.prefix,
      _ref$minValueLabelTem = _ref.minValueLabelTemplate,
      minValueLabelTemplate = _ref$minValueLabelTem === undefined ? null : _ref$minValueLabelTem,
      _ref$currentValueLabe = _ref.currentValueLabelTemplate,
      currentValueLabelTemplate = _ref$currentValueLabe === undefined ? null : _ref$currentValueLabe,
      _ref$maxValueLabelTem = _ref.maxValueLabelTemplate,
      maxValueLabelTemplate = _ref$maxValueLabelTem === undefined ? null : _ref$maxValueLabelTem,
      displayCustomValue = _ref.displayCustomValue;

  var getWrappedValue = function getWrappedValue(value) {
    return _react2.default.createElement(
      'em',
      { className: labelValueClassName },
      prefix,
      runValueFunction(value),
      postfix
    );
  };

  var getLabelTemplate = function getLabelTemplate(name) {
    switch (name) {
      case 'min':
        return minValueLabelTemplate;
      case 'current':
        return currentValueLabelTemplate;
      case 'max':
        return maxValueLabelTemplate;
      case 'any':
        return customLabelFunction ? null : 'Any';
      default:
        return null;
    }
  };

  var getLabel = function getLabel(_ref2) {
    var templateName = _ref2.templateName,
        hasSingleValue = _ref2.hasSingleValue;

    var template = getLabelTemplate(templateName);
    var useDefaults = !template;

    if (useDefaults) {
      if (hasSingleValue) {
        return renderValue();
      }

      return renderObjectValue();
    }

    var templateParts = template.split(/\{\d}/).map(function (part) {
      return part.trim();
    });

    if (hasSingleValue) {
      var hasPlaceholder = templateParts.length === 2;

      return hasPlaceholder ? _react2.default.createElement(
        'div',
        null,
        templateParts[0],
        ' ',
        getWrappedValue(value),
        ' ',
        templateParts[1]
      ) : _react2.default.createElement(
        'div',
        null,
        template
      );
    }

    var hasPlaceholders = templateParts.length === 3;

    return hasPlaceholders ? _react2.default.createElement(
      'div',
      null,
      templateParts[0],
      ' ',
      getWrappedValue(value.min),
      ' ',
      templateParts[1],
      ' ',
      getWrappedValue(value.max),
      ' ',
      templateParts[2]
    ) : _react2.default.createElement(
      'div',
      null,
      template
    );
  };

  var getTemplateNameFor = function getTemplateNameFor(value) {
    var templateMap = [{
      name: 'current',
      predicate: (0, _utils.isObject)(value) && (value.max !== maxValue || value.min !== minValue) || !(0, _utils.isObject)(value) && value !== minValue && value !== maxValue
    }, {
      name: 'min',
      predicate: !(0, _utils.isObject)(value) && value === minValue
    }, {
      name: 'max',
      predicate: !(0, _utils.isObject)(value) && value === maxValue
    }, {
      name: 'any',
      predicate: (0, _utils.isObject)(value) && value.max === maxValue && value.min === minValue
    }];

    var template = templateMap.find(function (template) {
      return template.predicate;
    });

    return template && template.name;
  };

  var formatCustomValue = function formatCustomValue(v) {
    return displayCustomValue ? displayCustomValue(v) : v;
  };
  var runValueFunction = function runValueFunction(v) {
    return labelValueFunction ? labelValueFunction(formatCustomValue(v)) : formatCustomValue(v);
  };
  var renderObjectValue = function renderObjectValue() {
    return customLabelFunction ? customLabelFunction({
      value: {
        min: runValueFunction(value.min),
        max: runValueFunction(value.max)
      },
      isMinValue: value.min === minValue,
      isMaxValue: value.max === maxValue,
      isAllRange: value.min === minValue && value.max === maxValue
    }) : value.max !== maxValue || value.min !== minValue ? _react2.default.createElement(
      'div',
      null,
      name + ' between ',
      getWrappedValue(value.min),
      ' and ',
      getWrappedValue(value.max)
    ) : _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'em',
        null,
        'Any'
      ),
      ' ' + name
    );
  };
  var renderValue = function renderValue() {
    return customLabelFunction ? customLabelFunction({
      value: runValueFunction(value),
      isMinValue: value === minValue,
      isMaxValue: value === maxValue
    }) : _react2.default.createElement(
      'div',
      null,
      getWrappedValue(value),
      ' ' + name
    );
  };

  var templateName = getTemplateNameFor(value);

  return getLabel({
    hasSingleValue: !(0, _utils.isObject)(value),
    templateName: templateName
  });
};

Label.propTypes = {
  className: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
  name: _propTypes2.default.string,
  prefix: _propTypes2.default.string,
  postfix: _propTypes2.default.string,
  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object]),
  minValue: _propTypes2.default.number,
  maxValue: _propTypes2.default.number
};

Label.defaultProps = {
  name: 'value',
  postfix: '',
  prefix: ''
};

exports.default = Label;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Slider/Label.js